import styled from 'styled-components'
import { BtnComponent, themeColor } from 'LibNeo'

export const UpBtnStyle = styled(BtnComponent)`
	left: 50%;
	background: ${themeColor('white')};
	border-radius: 8px;
	box-shadow: 0 8px 24px rgba(35, 43, 54, 0.16);
	border: 2px solid ${themeColor('white')};
	color: ${themeColor('emerald', 5)};
	pointer-events: auto;

	&:hover,
	&:focus {
		background: ${themeColor('white')};
		box-shadow: 0 8px 24px rgba(35, 43, 54, 0.32);
		border: 2px solid ${themeColor('white')};
		color: ${themeColor('emerald', 7)};

		svg {
			fill: ${themeColor('emerald', 7)};
		}
	}

	&:disabled {
		opacity: 0.6;
	}

	svg {
		fill: ${themeColor('emerald', 5)};
	}
`
export const Container = styled.div`
	position: absolute;
	bottom: 20px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	pointer-events: none;
`
